<!--
 * @Description: 生命状态
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<!-- 5 已经被一个客户占用了。status 表示生命状态的值最终改为：
 [{"isEnabled":true,"label":"审批中","sort":0,"sortable":true,"value":"1"},
 {"isEnabled":true,"label":"已生效","sort":1,"sortable":true,"value":"2"},
 {"isEnabled":true,"label":"未生效","sort":2,"sortable":true,"value":"3"},
 {"isEnabled":true,"label":"已作废","sort":3,"sortable":true,"value":"4"},
 {"isEnabled":true,"label":"变更中","sort":4,"sortable":true,"value":"6"}] -->

<!-- 列表和详情是后端处理过的（label值） -->
<template>
  <template v-if="getStatusCol()">
    <jw-tag size="small" :color="getStatusCol()">{{ props.status }}</jw-tag>
    <jw-tooltip content="审批流被退回，请重新编辑提交数据！">
      <icon-exclamation-circle-fill v-if="rollbackRoot" style="color: #ff7d00" />
    </jw-tooltip>
  </template>
  <span v-else>-</span>
</template>
<script setup>
const props = defineProps({
  status: {
    type: Number || String,
    default: ''
  },
  statusOrigin: {
    type: Number || String,
    default: ''
  },
  // 退回状态
  rollbackRoot: {
    type: Boolean,
    default: false
  }
});
const getStatusCol = () => {
  // 审批中
  if (props.statusOrigin == '1' || props.status == '审批中') return 'gold';
  // 已生效
  else if (props.statusOrigin == '2' || props.status == '已生效') return 'green';
  // 未生效
  else if (props.statusOrigin == '3' || props.status == '未生效' || props.status == '待补充明细') return 'gray';
  // 变更中
  else if (props.statusOrigin == '6' || props.status == '变更中') return 'cyan';
  // 已作废
  else if (props.statusOrigin == '4' || props.status == '已作废') return 'red';
  else return '';
};
</script>
